import React from 'react';
import { Card, CardContent } from './ui/card';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';

export default function MetricCard({ label, value, changePct, prefix = '', suffix = '' }) {
  const isUp = changePct > 0;
  const isDown = changePct < 0;
  const isNeutral = changePct === 0;

  return (
    <Card className="metric-card-hover" data-testid="metric-card">
      <CardContent className="p-5">
        <div className="text-xs uppercase tracking-wider text-muted-foreground mb-2"
             style={{ letterSpacing: '0.08em' }}>
          {label}
        </div>
        <div
          className="text-2xl sm:text-3xl font-semibold tracking-tight tabular-nums"
          style={{ fontFamily: 'Space Grotesk, sans-serif', color: '#1f2a4d' }}
          data-testid="metric-card-value"
        >
          {value == null ? '—' : `${prefix}${typeof value === 'number' ? value.toLocaleString() : value}${suffix}`}
        </div>
        <div className="mt-2" data-testid="metric-card-delta">
          <span
            className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${
              isUp
                ? 'text-emerald-700 bg-emerald-50 border-emerald-100'
                : isDown
                ? 'text-red-700 bg-red-50 border-red-100'
                : 'text-slate-700 bg-slate-50 border-slate-100'
            }`}
          >
            {isUp && <ArrowUp size={12} />}
            {isDown && <ArrowDown size={12} />}
            {isNeutral && <Minus size={12} />}
            {changePct == null ? 'Comparison unavailable' : `${Math.abs(changePct).toLocaleString(undefined, { maximumFractionDigits: 1 })}%`}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
